import { cn } from '../../..';

import { GapProps } from './types';

export type GridProps = React.HTMLAttributes<HTMLDivElement> & {
  cols1?: boolean;
  cols2?: boolean;
  cols3?: boolean;
  cols4?: boolean;
  cols5?: boolean;
  cols6?: boolean;
  cols7?: boolean;
  cols8?: boolean;
  cols9?: boolean;
  cols10?: boolean;
  rows1?: boolean;
  rows2?: boolean;
  rows3?: boolean;
  rows4?: boolean;
  rows5?: boolean;
  rows6?: boolean;
  rows7?: boolean;
  rows8?: boolean;
  rows9?: boolean;
  rows10?: boolean;
} & GapProps;

export const Grid = ({
  className,
  cols1,
  cols2,
  cols3,
  cols4,
  cols5,
  cols6,
  cols7,
  cols8,
  cols9,
  cols10,
  rows1,
  rows2,
  rows3,
  rows4,
  rows5,
  rows6,
  rows7,
  rows8,
  rows9,
  rows10,
  gap0,
  gap1,
  gap2,
  gap3,
  gap4,
  gap5,
  gap6,
  gap7,
  gap8,
  gap9,
  gap10,
  gap,
  ...props
}: GridProps) => (
  <div
    className={cn(
      '@Grid grid',
      cols1 && 'grid-cols-1',
      cols2 && 'grid-cols-2',
      cols3 && 'grid-cols-3',
      cols4 && 'grid-cols-4',
      cols5 && 'grid-cols-5',
      cols6 && 'grid-cols-6',
      cols7 && 'grid-cols-7',
      cols8 && 'grid-cols-8',
      cols9 && 'grid-cols-9',
      cols10 && 'grid-cols-10',
      rows1 && 'grid-rows-1',
      rows2 && 'grid-rows-2',
      rows3 && 'grid-rows-3',
      rows4 && 'grid-rows-4',
      rows5 && 'grid-rows-5',
      rows6 && 'grid-rows-6',
      rows7 && 'grid-rows-7',
      rows8 && 'grid-rows-8',
      rows9 && 'grid-rows-9',
      rows10 && 'grid-rows-10',
      gap0 && 'gap-0',
      gap1 && 'gap-1',
      gap2 && 'gap-2',
      gap3 && 'gap-3',
      gap4 && 'gap-4',
      gap5 && 'gap-5',
      gap6 && 'gap-6',
      gap7 && 'gap-7',
      gap8 && 'gap-8',
      gap9 && 'gap-9',
      gap10 && 'gap-10',
      className,
    )}
    {...props}
    style={{ ...props.style, gap }}
  />
);
